/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_add_new_passkey_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Give your passkey a memorable name to identify this device.`)
};

const zh_hans1_settings_add_new_passkey_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`给您的通行密钥起一个容易记住的名字，以便识别此设备。`)
};

const zh_hant1_settings_add_new_passkey_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`為通行金鑰取一個好記的名稱，以便辨識此裝置。`)
};

const fr_settings_add_new_passkey_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donnez à votre passkey un nom mémorable pour identifier cet appareil.`)
};

const de_settings_add_new_passkey_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib deinem Passkey einen einprägsamen Namen, um dieses Gerät zu erkennen.`)
};

const ja_settings_add_new_passkey_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この端末を識別できるよう、覚えやすい名前を付けてください。`)
};

const ko_settings_add_new_passkey_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 기기를 식별할 수 있도록 기억하기 쉬운 패스키 이름을 지정하세요.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_add_new_passkey_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_add_new_passkey_desc(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_add_new_passkey_desc", locale)
	if (locale === "en") return en_settings_add_new_passkey_desc(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_add_new_passkey_desc(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_add_new_passkey_desc(inputs)
	if (locale === "fr") return fr_settings_add_new_passkey_desc(inputs)
	if (locale === "de") return de_settings_add_new_passkey_desc(inputs)
	if (locale === "ja") return ja_settings_add_new_passkey_desc(inputs)
	return ko_settings_add_new_passkey_desc(inputs)
};